import React from "react";
import { Box } from "@mui/material";

const CustomBox = ({ children, ...props }) => {
  return (
    <Box
      sx={{
        py: 1,
        px: 2,
        mb: 4,
        borderRadius: "2px",
        boxShadow: "0px 1px 6px #00000029",
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default CustomBox;
